<template>
  <div>
  <div v-if="selectedDoc">
    <div class="flex justify-between mt-6">
      <button type="button" @click="selectedDoc = null" class="bg-white hover:bg-tertiary active:bg-primary text-primary hover:text-white py-2 px-6 text-sm border border-tertiary hover:border-transparent rounded shadow">
        Back
      </button>

      <button type="button" @click="showDeleteModal = selectedDoc" class="bg-white hover:bg-tertiary active:bg-primary text-primary hover:text-white py-2 px-6 text-sm border border-tertiary hover:border-transparent rounded shadow">
        Delete Saved Document
      </button>
    </div>

    <DocumentForm :saved-doc-id="selectedDoc" />
  </div>
  <div v-else>
    <div class="flex flex-wrap -mx-2 mt-6">
      <div class="w-full md:w-1/4 px-2">
        <input type="text" v-model="searchParams.q" placeholder="Search" class="w-full rounded bg-white p-3" />
      </div>
      <div class="w-full md:w-1/4 px-2">
        <select v-model="searchParams.document_id" class="w-full rounded bg-white p-3">
          <option :value="null">[All Documents]</option>
          <option v-for="doc in documents" :key="doc.id" :value="doc.id">
            {{ doc.name }}
          </option>
        </select>
      </div>
    </div>

    <loader v-if="savedDocuments === null" class="mt-6" />
    <panel v-else-if="savedDocuments.data.length === 0" class="mt-6 pt-6">
      <div>
        <i class="fas fa-info-circle"></i> Your search returned no results.
      </div>
    </panel>
    <panel class="mt-6 pt-6" v-else>
      <div class="w-full max-w-full overflow-x-auto overflow-y-hidden px-1">
        <table class="table-auto text-center w-full">
          <thead class="uppercase text-xs">
            <tr>
              <th class="text-left p-2 whitespace-no-wrap">Template</th>
              <th class="text-left p-2 whitespace-no-wrap">Document</th>
              <th class="text-left p-2 whitespace-no-wrap">Saved Documents</th>
              <th class="text-left p-2 whitespace-no-wrap"></th>
            </tr>
          </thead>
          <tbody class="text-sm">
            <tr v-for="doc in savedDocuments.data" :key="doc.id" class="border-t border-grey-lighter">
              <td class="text-left p-2">
                {{ doc.document.name }}
              </td>
              <td class="text-left p-2">
                {{ doc.name }}
              </td>
              <td class="text-left p-2">
                {{ doc.updated_at | date }}, {{ doc.updated_at | time }}, {{ doc.updated_by ? doc.updated_by.name : '' }}
              </td>
              <td class="text-right p-2">
                <button type="button" @click="showDeleteModal = doc.id" class="bg-white hover:bg-tertiary active:bg-primary text-primary hover:text-white py-2 px-6 text-sm border border-tertiary hover:border-transparent rounded shadow">
                  Delete Document
                </button>
                <button type="button" @click="selectedDoc = doc.id" class="bg-white hover:bg-tertiary active:bg-primary text-primary hover:text-white py-2 px-6 text-sm border border-tertiary hover:border-transparent rounded shadow ml-2">
                  View Document
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <paginator :data="savedDocuments" @change="pageChanged"/>
    </panel>
  </div>
  <deletion-modal
    v-if="showDeleteModal"
    :loading="deletingDoc"
    confirm-label="Yes, delete"
    cancel-label="Cancel"
    @confirmed="deleteDoc(showDeleteModal)"
    @leave="showDeleteModal = false"
    @dismissed="showDeleteModal = false">
    <p class="text-center">Are you sure you want to delete this saved document?</p>
  </deletion-modal>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import { mapActions, mapState } from 'vuex'
import DocumentForm from './DocumentForm.vue'
import debounce from 'lodash/debounce'
import DeletionModal from '@/components/Modals/DeletionModal'

export default {
  components: { DocumentForm, DeletionModal },
  data () {
    return {
      documents: [],
      savedDocuments: null,
      searchParams: {
        q: null,
        document_id: null,
        page: 1
      },
      selectedDoc: null,
      showDeleteModal: false,
      deletingDoc: false
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  created () {
    this.getDocuments()
  },
  methods: {
    ...mapActions(['displayToastNotification']),
    getDocuments () {
      v2Api.get('documents', {
        params: {
          office_id: this.selectedOffice.id,
          list: true
        }
      }).then((response) => {
        this.documents = response.data
      })
    },
    search: debounce(function () {
      v2Api.get('saved-documents', {
        params: {
          ...this.searchParams,
          office_id: this.selectedOffice.id
        }
      }).then((response) => {
        this.savedDocuments = response.data
      })
    }, 500),
    pageChanged (page) {
      this.searchParams.page = page
    },
    deleteDoc (docId) {
      v2Api.delete(`saved-documents/${docId}`).then(() => {
        this.selectedDoc = null
        this.showDeleteModal = false
        this.search()
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check-circle',
          title: 'Deleted',
          info: 'The saved document has been deleted.'
        })
      })
    }
  },
  watch: {
    selectedOffice: {
      handler () {
        this.getDocuments()
        this.search()
      },
      deep: true
    },
    searchParams: {
      handler () {
        this.search()
      },
      deep: true
    },
    selectedDoc: {
      handler (val) {
        if (val === null) {
          this.savedDocuments = null
          this.search()
        }
      },
      immediate: true
    }
  }
}
</script>
